export default [  
  {
    path: '/partner-account',
    name: 'partner-account',
    component: () => import('@/views/modules/partner-account/account'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Account',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Account' }
      ]
    },
    
  },

  {
    path: '/partner-account-invoices/',
    name: 'partner-account-invoices',
    component: () => import('@/views/modules/partner-account/invoices'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Invoices',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Invoices' }
      ]
    },   
     
    
  },

  {
    path: '/partner-account-payments',
    name: 'partner-account-payments',
    component: () => import('@/views/modules/partner-account/payments'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Payments',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Payments' }
      ]
    },   
    
  },

  {
    path: '/partner-account-credits',
    name: 'partner-account-credits',
    component: () => import('@/views/modules/partner-account/credits'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Credits',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Credits' }
      ]
    },   
    
  },

  {
    path: '/partner-account-debits',
    name: 'partner-account-debits',
    component: () => import('@/views/modules/partner-account/debits'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Debits',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Debits' }
      ]
    },   
    
  },

  {
    path: '/partner-account-statement',
    name: 'partner-account-statement',
    component: () => import('@/views/modules/partner-account/statement'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Statement',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Statement' }
      ]
    },   
    
  },

  
 
]